export default "__VITE_ASSET__mjmcaeir__"